import { showAlert } from '@silverfort/sf-components';
import moment from 'moment/moment';
import { ServiceAccount, ServiceAccountData } from '../ServiceAccountsTypes';

export type ActionError = 'discarding' | 'updating' | 'reinstating';

export const showAlertError = (action: ActionError) => {
    showAlert(
        `An error occurred ${action} the account. Please try again. If the problem persists, contact your Silverfort Representative.`,
        'error'
    );
};

export const convertServiceAccountDataToServiceAccount = (
    data: ServiceAccountData
): Pick<ServiceAccount, 'id' | 'guid' | 'is_protected' | 'display_name'> => {
    return {
        id: data.id,
        guid: data.guid,
        is_protected: data.is_protected,
        display_name: data.display_name
    };
};

export const calculateBaselineDays = (date: number) => {
    const days = moment(Date.now()).diff(moment(date), 'days');
    if (days === 0) return '< 1 day';
    if (days === 1) return '1 day';
    if (days > 365) return 'Over 1 year';
    return `${days} days`;
};

const sortByIdentifier = (a, b) => {
  if (a.identifier < b.identifier) return -1;
  if (a.identifier > b.identifier) return 1;
  return 0;
};

const hasIdentifier = (arr: any[]) =>
    arr.length > 0 && arr.length > 0 && typeof arr[0] === 'object' && arr[0] !== null && 'identifier' in arr[0];

export const compareValues = (value1: any, value2: any): boolean => {
    if (value1 === value2 || (!value1 && !value2)) {
        return true;
    }
    if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length !== value2.length) {
            return false;
        }
        let sorted1;
        let sorted2;

        if (!hasIdentifier(value1) && !hasIdentifier(value2)) {
            sorted1 = [...value1].sort();
            sorted2 = [...value2].sort();
        } else {
            sorted1 = [...value1].sort(sortByIdentifier);
            sorted2 = [...value2].sort(sortByIdentifier);
        }
       
        return sorted1.every((v, i) => compareValues(v, sorted2[i]));
    }
    if (typeof value1 === 'object' && typeof value2 === 'object' && value1 && value2) {
        const keys1 = Object.keys(value1);
        const keys2 = Object.keys(value2);
        return keys1.length === keys2.length && keys1.every((key) => compareValues(value1[key], value2[key]));
    }
    return false;
};
